import React from 'react';
import PropTypes from 'prop-types';

import Navigation from './Navigation';
import Logo from 'Components/Shared/Logo/Logo.js';
import HeaderImage from './HeaderImage';

import './Header.module.css';

Header.propTypes = {
  data: PropTypes.shape({
    slogan_line1: PropTypes.string.isRequired,
    slogan_line2: PropTypes.string.isRequired,
    facebook: PropTypes.string.isRequired,
    instagram: PropTypes.string.isRequired,
    navigation: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
    })),
  }).isRequired,
};

function Header({ data }) {
  return (
    <header styleName="Header">
      <div styleName="line1Container" className="wrapper">
        <Logo />
        <Navigation data={data} />
      </div>
      <HeaderImage data={data} />
    </header>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js